export default {
    __id              : 'header',
    _selector        : '.toggle-mobile-menu',
    init() {
        document.getElementById

        const buttons = document.querySelectorAll(this._selector);

        if (! buttons) {
            return;
        }

        buttons.forEach((el) => el.addEventListener('click', (event) => {
            const button =  event.target.classList.contains('toggle-mobile-menu') ?
                            event.target :
                            event.target.closest('.toggle-mobile-menu');


            document.querySelector('.mobile-menu-layer').classList.toggle('active');
        }));


    },

};